module.exports = __webpack_public_path__ + "prod/1.42.2/img/code.d9c9077e.png";